import React from "react";
import withStyles from "@mui/styles/withStyles";
import { CircularProgress } from "@mui/material";

import styles from "../styles";
import { useGetClinicalLeads } from "hooks/useGetClinicalLeads";
import ANFormView from "elements/Forms/ANFormView";
import SectionBox from "elements/SectionBox";
import { dateWithoutTimezone } from "utils/dateWithoutTimezone";

function getEmploymentOptions() {
  return [
    { value: "W2_1_FTE", label: "BCBA - W2 1 FTE", maxBH: 36 },
    { value: "W2_75_FTE", label: "BCBA - W2 .75 FTE", maxBH: 27 },
    { value: "W2_5_FTE", label: "BCBA - W2 .5 FTE", maxBH: 19 },
    { value: "Contractor", label: "BCBA - Contractor" },
    { value: "Clinical_Assessor", label: "Clinical Assessor" },
    { value: "Clinical_Lead", label: "Clinical Lead" },
  ];
}

const EmploymentDetails = (props) => {
  const { basicInfo } = props;
  const { leads, leadsLoading } = useGetClinicalLeads();

  if (leadsLoading) return <CircularProgress />;

  const findLeadById = (id) => {
    const supervisor = leads.find((lead) => lead.user_id === id);
    return supervisor ? supervisor.first_name + " " + supervisor.last_name : "";
  };

  const employmentOptions = getEmploymentOptions();

  return (
    <SectionBox
      title="Employment Details"
      description={"Employment status and managing supervisor"}
      columnDirection
    >
      <ANFormView
        data={{
          employmentType:
            employmentOptions.find((option) => option.value === basicInfo?.employment_type)
              ?.label || "",
          maxBillableHour: basicInfo?.max_billable_hour || "",
          supervisor: findLeadById(basicInfo?.supervisor_user_id) || "",
          employmentStartDate: basicInfo?.start_date
            ? dateWithoutTimezone(basicInfo?.start_date)
            : null,
          employmentLastDate: basicInfo?.end_date ? dateWithoutTimezone(basicInfo?.end_date) : null,
        }}
        config={[
          { label: "Employment Type", dataKey: "employmentType", cols: 6, type: "select" },
          {
            label: "Supervisor",
            dataKey: "supervisor",
            type: "select",
            cols: 6,
          },
          {
            label: "Employment Start Date",
            dataKey: "employmentStartDate",
            format: "jsonDate",
            cols: 6,
          },
          {
            label: "Employment Last Day",
            dataKey: "employmentLastDate",
            format: "jsonDate",
            cols: 6,
          },
        ]}
      ></ANFormView>
    </SectionBox>
  );
};

export default withStyles(styles)(EmploymentDetails);
